/**
 * @React
 */
import { FC } from "react";
/**
 * @Mui
 */
import { ImageList, ImageListItem } from "@mui/material";

interface IMonitoringImagesGalleryProps {
  imagesList: (string | { original_path: string; signed_url: string })[];
}

const MonitoringImagesGallery: FC<IMonitoringImagesGalleryProps> = ({ imagesList }: IMonitoringImagesGalleryProps) => {
  const baseUrl = process.env.REACT_APP_BASE_URL || "";

  return (
    <ImageList sx={{ width: "100%" }} cols={3} rowHeight={230} gap={10}>
      {imagesList.map((item, index) => {
        const filePath = typeof item === "string" ? item : item.original_path;
        let fileUrl: string;
        if (typeof item === "string") {
          if (item.startsWith("uploads/")) {
            fileUrl = `${baseUrl}file/${encodeURIComponent(item)}`;
          } else {
            fileUrl = `${baseUrl}${item}`;
          }
        } else {
          fileUrl = item.signed_url;
        }

        return (
          <a key={`${filePath}-${index}`} href={fileUrl}>
            <ImageListItem key={`${filePath}-${index}`}>
              <img srcSet={fileUrl} src={fileUrl} alt={"File"} loading="lazy" />
            </ImageListItem>
          </a>
        );
      })}
    </ImageList>
  );
};

export default MonitoringImagesGallery;
/**
 *   const columns = [
    {
      field: "bank",
      headerName: "ბანკი",
      flex: 2,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        return params.row.bank.name;
      },
    },
    { field: "amount", headerName: "თანხა", flex: 2, headerAlign: "center", align: "center" },
    { field: "interest_amount", headerName: "პროცენტი", flex: 2, headerAlign: "center", align: "center" },
    { field: "principal_amount", headerName: "ძირი", flex: 2, headerAlign: "center", align: "center" },
    {
      field: "date",
      headerName: "თარიღი",
      flex: 2,
      headerAlign: "center",
      align: "center",
      type: "date",
      valueGetter: (params) => {
        return dateFormat(params.row.date, "yyyy-mm-dd", true);
      },
    },
  ];

  return (
    <div style={{ marginTop: 30, height: 400, width: "100%" }}>
      <DataGrid getRowId={(row) => row._id} rows={rows} columns={columns} pageSize={100} rowsPerPageOptions={[5]} disableColumnMenu hideFooter />;
    </div>
  );
}
 */
